import React from 'react';
import { Link } from 'react-router-dom';
import './ProfileSettings.css';

function ProfileSettings() {
  return (
    <div className="profile-settings">
      <div className="container">
        <h1>Profile Settings</h1>

        <div className="settings-section">
          <h2>Account Management</h2>

          <div className="setting-item">
            <h3>Personal Information</h3>
            <p>Manage your account details and preferences.</p>
            <button className="btn-secondary">Edit Profile</button>
          </div>

          <div className="setting-item">
            <h3>Privacy Settings</h3>
            <p>Control your privacy and data sharing preferences.</p>
            <button className="btn-secondary">Manage Privacy</button>
          </div>

          <div className="setting-item danger-zone">
            <h3>Delete Account</h3>
            <p>Permanently delete your account and all associated data.</p>
            <Link to="/account-deletion" className="btn-danger">
              Request Account Deletion
            </Link>
          </div>
        </div>

        <div className="back-link">
          <Link to="/">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
}

export default ProfileSettings;
